import { Component ,Renderer2} from '@angular/core';
import { CommonModule } from '@angular/common';
import { ActivatedRoute,NavigationEnd,Router} from '@angular/router';
import { NewsletterService } from '../../../services/newsletter.service';
import { filter, map, mergeMap } from 'rxjs';

@Component({
  selector: 'app-techgeek-cover',
  imports: [CommonModule],
  standalone:true,
  templateUrl: './techgeek-cover.component.html',
  styleUrl: './techgeek-cover.component.scss'
})
export class TechgeekCoverComponent {
constructor(
    private NewsletterService: NewsletterService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private render: Renderer2
  ) {}

  ngOnInit(): void {
    this.router.events.pipe(
      filter((event: any) => event instanceof NavigationEnd),
      map(() => this.activatedRoute),
      map((route) => {
        while (route.firstChild) route = route.firstChild;
        return route;
      }),
      filter((route) => route.outlet === 'primary'),
      mergeMap((route: { data: any }) => route.data)
    )
  }

  techgeekcards = [
    {
      month: 'Edition 1',
      imagePath: 'assets/resources/techgeek/Tech Geek_1.webp',
      postedOn: '25 November 2022',
      title:'Tech Geek Edition5',
      clickMethod: () => this.router.navigate(['/kalpita-tech-geek/techgeek-1'])
    },
    {
      month: 'Edition 2',
      imagePath: 'assets/resources/techgeek/Tech Geek_2.webp',
      postedOn: '29 March 2023',
      title:'Tech Geek Edition5',
      clickMethod: () => this.router.navigate(['/kalpita-tech-geek/techgeek-2'])
    },
        {
      month: 'Edition 3',
      imagePath: 'assets/resources/techgeek/Tech Geek_3.webp',
      postedOn: '29 September 2023',
      title:'Tech Geek Edition5',
      clickMethod: () => this.router.navigate(['/kalpita-tech-geek/techgeek-3'])
    },
        {
      month: 'Edition 4',
      imagePath: 'assets/resources/techgeek/Tech Geek_4.webp',
      postedOn: '24 December 2024',
      title:'Tech Geek Edition5',
      clickMethod: () => this.router.navigate(['/kalpita-tech-geek/techgeek-4'])
    },
    {
      month: 'Edition 5',
      imagePath: 'assets/resources/techgeek/Tech Geek_5.webp',
      postedOn: '28 August 2025',
      title:'Tech Geek Edition5',
      clickMethod: () => this.router.navigate(['/kalpita-tech-geek/techgeek-5'])
    },
     {
      month: 'Edition 6',
      imagePath: 'assets/resources/techgeek/tech-geek-6-coverimg.png',
      postedOn: '07 April 2026',
      title:'Tech Geek Edition6',
      clickMethod: () => this.router.navigate(['/kalpita-tech-geek/techgeek-6'])
    }
  ];
  navigateToHome(): void {
    this.router.navigate(['/']);
  }
  // handleClick(imagePath: string) {
  //   if (imagePath.startsWith('http://') || imagePath.startsWith('https://')) {
  //     window.open(imagePath, '_blank');
  //   } else {
  //     localStorage.setItem('selectedImage', imagePath);
  //     this.router.navigate(['/tech-geeks/techgeek']);
  //   }
  // }
}
